import StatisticsTable from './StatisticsTableContainer';

export default StatisticsTable;
